import * as React from 'react';
import { Link } from 'react-router-dom';
import { UitkSelect } from 'uitk-react-select';
import { UitkSpacing } from 'uitk-react-spacing';

export interface ChildComponentProps {
  roomCount: any;
  childCount: any;
  totalChild: any;
  onAgeChange(event: any): any;
}

export class ChildComponent extends React.Component<ChildComponentProps, any> {
  public constructor(props) {
    super(props);
  }

  public renderAgeDropDown() {
    const childAge = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];
    const childAgeDropDown = childAge.map((age) => {
      return (
        <option key={age} value={age}>
          {age}
        </option>
      );
    });

    return childAgeDropDown;
  }

  public render() {
    const { roomCount, childCount, onAgeChange, totalChild } = this.props;

    return (
      <UitkSpacing  margin={{ block: 'three' }}>
        <UitkSelect
          id={`childAge-${roomCount}-${childCount}-${totalChild}`}
          label="select the child age"
          onChange={onAgeChange}
        >
          {this.renderAgeDropDown()}
        </UitkSelect>
      </UitkSpacing>
    );
  }
}
